import {Assignment, ActionableType, AssignmentType} from '@/assignments/Assignment.type'
import {h} from 'vue'
import BookkeepableDetails from '@/assignments/BookkeepingActionable/BookkeepableDetails.vue'
import SubAccountCreatableDetails from '@/assignments/SubAccountCreatable/SubAccountCreatableDetails.vue'
import IncomingInvoiceReviewAssignment from '@/assignments/details/IncomingInvoiceReviewAssignment.vue'

export const resolveDetailsComponent = (assignment: Assignment) => {
    // Route by assignment type first (before checking actionable type)
    if (assignment.type === AssignmentType.IncomingInvoiceReview) {
        return IncomingInvoiceReviewAssignment
    }

    const actionable = assignment.context
    if(!actionable) return h('div', 'No details')
    switch (actionable.type) {
        case ActionableType.Approve:
            return h('div', 'Approvable')
        case ActionableType.Bookkeepable:
            return BookkeepableDetails
        case ActionableType.SubAccountCreatable:
            return SubAccountCreatableDetails
        default:
            return h('div', 'Not found')
    }
}